module.exports = __webpack_public_path__ + "img/Icon-Transparence.749de21c.png";